import React, {SyntheticEvent, useEffect, useState} from "react";
import {v4} from "uuid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import {
    Radio,
    Grid,
    Checkbox,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    List,
    ListItem,
    ListSubheader,
    Typography
} from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import {rollStep} from "../../_helper/rollStep";
import {displayMod} from "../../_helper/displayMod";
import {rollerSetRolled} from "../../_helper/rollBehave";
import {
    s_char,
    s_char_disciplines,
    s_char_matricespells,
    s_char_talents
} from "../../_signals/s_char";
import {s_char_attr_step} from "../../_signals/s_char_attr";
import {mod_15} from "../../_helper/mod_15";
import {IDataSpell, ISpellAdditionalThreads} from "../../_interfaces/IDataSpell";
import {ICharTalent} from "../../_interfaces/ICharTalent";
import {IRollerResult} from "../../_interfaces/IRoller";
import Button from "@mui/material/Button";
import {getCastingTalent} from "./getCastingTalent";
import {ICharDiscipline} from "../../_interfaces/ICharDiscipline";
import {ResultsAdd} from "../../_api/BEResult";
import {IResult} from "../../_interfaces/IResult";
import {charModsGetMod} from "../../_sig_api/charMods";
import {MatricespellsUpdate} from "../../_api/BEMatricespells";
import {InfoSpellSubscriber} from "../../_helper/InfoSpellBehave";
import {ICharMatriceSpell} from "../../_interfaces/ICharMatriceSpell";
import {SpellsSubscriber} from "../../_helper/DataBehaves";
import {s_chars} from "../../_signals/s_chars";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import {IChar} from "../../_interfaces/IChar";
import {s_app_rid, s_app_sl} from "../../_signals/s_app";
import {styled} from "@mui/material/styles";
import ccAttribute from "../../_helper/ccAttribute";

const Item = styled("div")(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2,
    padding: 4,
    textAlign: 'left',
    color: '#000',
}));

interface IProp {
    cast: string
    isOpen: (open: boolean) => void
}

function MatriceSpellCasting({cast, isOpen}: IProp) {

    const diff = [...Array(61).keys()];


    const [castingOpen, setCastingOpen] = useState(false)
    const [castingDiscipline, setCastingDiscipline] = useState<ICharDiscipline | null>(null) // Talent Spruchzauberei
    const [castingTalent, setCastingTalent] = useState<ICharTalent | null>(null) // Talent Spruchzauberei

    const [castingKarma, setCastingKarma] = useState(false)
    const [castingMod, setCastingMod] = useState(0)
    const [castingVS, setCastingVS] = useState(0)
    const [castingSpell, setCastingSpell] = useState<ICharMatriceSpell | null>(null)

    const [usedSpell, setUsedSpell] = useState<IDataSpell | null>(null)

    const [castingAt, setCastingAt] = useState<string[]>([]) // zusätzliche fäden verwenden für
    const [castingResult, setCastingResult] = useState<IRollerResult | null>(null)

    const [effMod, setEffMod] = useState(0)
    const [effKarma, setEffKarma] = useState(false)
    const [effectResult, setEffectResult] = useState<IRollerResult | null>(null)

    // ziele bei vstarget z, e,g,g+
    const [targets, setTargets] = useState<string[]>([])

    const [targetOpen, setTargetOpen] = useState<boolean>(false)

    const handleSingleTarget = (id: string) => {
        const currentIndex = targets.indexOf(id);
        let newTargets: string[] = [];

        if (currentIndex === -1) {
            newTargets.push(id);
        } else {
            newTargets = [];
        }

        setTargets(newTargets);
    }

    const chooseSingleTarget = () => {
        return <List dense={true} sx={{width: '100%', bgcolor: 'background.paper'}}>
            {Array.from(s_chars.value.entries()).map(([, char]) => {
                if (!available(char)) return null
                const labelId = `checkbox-list-label-${char.id}`;
                return (
                    <ListItem key={'liid' + char.id}
                              style={{width: "100%"}}
                    >
                        <ListItemButton role={undefined} onClick={() => handleSingleTarget(char.id)} dense>
                            <ListItemIcon>
                                <Radio
                                    checked={targets.includes(char.id)}
                                />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={char.name}/>
                        </ListItemButton>
                    </ListItem>
                )
            })}
        </List>
    }

    const handleMultipleTarget = (id: string) => {
        const currentIndex = targets.indexOf(id);
        const newTargets = [...targets];

        if (currentIndex === -1) {
            newTargets.push(id);
        } else {
            newTargets.splice(currentIndex, 1);
        }

        setTargets(newTargets);
    }

    const chooseMultipleTarget = () => {
        return <List dense={true} sx={{width: '100%', bgcolor: 'background.paper'}}>
            {Array.from(s_chars.value.entries()).map(([, char]) => {
                if (!available(char)) return null
                const labelId = `checkbox-list-label-${char.id}`;
                return (
                    <ListItem key={'liid' + char.id}
                              style={{width: "100%"}}
                    >
                        <ListItemButton role={undefined} onClick={() => handleMultipleTarget(char.id)} dense>
                            <ListItemIcon>
                                <Checkbox
                                    edge="start"
                                    checked={targets.includes(char.id)}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{'aria-labelledby': labelId}}
                                />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={char.name}/>
                        </ListItemButton>
                    </ListItem>
                )
            })}
        </List>
    }


    useEffect(() => {
        console.log('casting useEffect', cast)
        if (!cast) return

        let matriceSpells = s_char_matricespells.value;
        const matrixSpell = matriceSpells.find((s) => s.id === cast);
        setCastingSpell(matrixSpell ?? null)

        if (matrixSpell) {
            let spell = SpellsSubscriber.value.find(s => s.name === matrixSpell.name)
            if (!spell) setUsedSpell(null)
            else setUsedSpell(spell)
            if (!spell) return;
        } else setUsedSpell(null)

        let disciplines = s_char_disciplines.value
        const disciplin = disciplines.find((d) => d.name === matrixSpell?.discipline);
        setCastingDiscipline(disciplin ?? null)

        setCastingTalent(getCastingTalent())

        setCastingOpen(true)

    }, [cast]);

    const available = (char: IChar) => {
        if (s_app_sl.value || !char.nsc) return true
        return char.nsc && char.visible;
    }

    const chooseAt = (i: string) => {

        let current = castingAt;
        // noch nichts ausgewählt, einfach einfügen
        if (current.length < 1) {
            current = [i]
            return current
        }

        if (!castingDiscipline) return []
        const maxAdd = Math.ceil(castingDiscipline.circle / 4);

        const found = current.findIndex(v => v === i);

        // faden entfernen
        if (found >= 0) {
            current.splice(found, 1);
        } else {
            if (current.length < maxAdd) {
                current.push(i);
            } else {
                current = [i];
            }
        }
        setCastingAt(current)
        return current;
    }


    const effectRoll = () => {
        if (!usedSpell || !usedSpell.eff_roll || !usedSpell.eff_roll.attribute || !castingSpell) return

        let step = s_char_attr_step(usedSpell.eff_roll.attribute).value;
        if (usedSpell.eff_roll.attribute === 'wil') {
            const talents = s_char_talents.value;
            let wil = talents.find((s) => s.name === "Willensstärke");
            if (wil) step = step + wil.step;
        }

        step = step + usedSpell.eff_roll.mod;
        step = step + effMod;
        step = step + s_char_attr_step(usedSpell.eff_roll.attribute).value;
        step = step + charModsGetMod(s_char.value.id, usedSpell.eff_roll.attribute);

        let addThreadEff: string[] = [];
        castingAt.forEach(at => {
            const ate = usedSpell.at[at] as ISpellAdditionalThreads;
            if (ate) {
                addThreadEff.push(ate.txt)
                if (ate.what && ate.what.includes('eff_roll') && ate.mod) {
                    step = step + ate.mod;
                }
            }
        });

        const rolled = rollStep(step, effKarma, 0);

        setEffectResult(rolled);
        rollerSetRolled(true);
        let rolledResult: IResult = {
            karma: rolled.karma,
            name: s_char.value.name,
            nsc: s_char.value.nsc,
            rid: s_app_rid.value,
            rollas: rolled.as,
            rolled: rolled.rolled,
            rollvs: rolled.vsnum,
            sl: s_app_sl.value,
            step: rolled.step,
            step_mod: rolled.step_mod,
            success: rolled.success,
            successes: rolled.successes,
            time: rolled.time,
            id: v4(),
            cid: s_char.value.id,
            title: 'Wirkung  ' + castingSpell.name,
            eff: usedSpell.eff,
            addEff: addThreadEff.join(','),
            result: rolled.result
        };
        ResultsAdd(rolledResult);
    }

    const castingRoll = () => {
        if (!castingTalent || !castingSpell) return

        let step = s_char_attr_step(castingTalent.attribute).value;
        step = step + castingTalent.step;
        step = step + castingMod;
        step = step + charModsGetMod(s_char.value.id, castingTalent.attribute);

        const rolled = rollStep(step, castingKarma, castingVS);

        setCastingResult(rolled);
        rollerSetRolled(true);

        let result: IResult = {
            addEff: '',
            cid: s_char.value.id,
            eff: '',
            id: v4(),
            karma: rolled.karma,
            name: s_char.value.name,
            nsc: s_char.value.nsc,
            result: rolled.result,
            rid: s_app_rid.value,
            rollas: rolled.as,
            rolled: rolled.rolled,
            rollvs: rolled.vsnum,
            sl: s_app_sl.value,
            step: rolled.step,
            step_mod: rolled.step_mod,
            success: rolled.success,
            successes: rolled.successes,
            time: rolled.time,
            title: castingTalent.name + ' ' + castingSpell.name
        };

        ResultsAdd(result);
    }

    const castingRollDone = () => {

        let matriceSpells = s_char_matricespells.value;
        matriceSpells = matriceSpells.map(ms => {
            if (ms.id === castingSpell?.id) {
                // fäden des spruchen zurücksetzten, update db
                ms.threadswoven = 0
                MatricespellsUpdate(ms)
            }
            return ms
        })
        s_char_matricespells.value = matriceSpells;

        castclose()
    }

    const handlePopOpen = (name: string, event: SyntheticEvent) => {
        let spell = SpellsSubscriber.value.find((s) => s.name === name);
        if (spell) InfoSpellSubscriber.next({popOpen: true, popEl: event.currentTarget, pop: spell})
    }

    const castclose = () => {
        setCastingResult(null)
        setEffectResult(null)
        setCastingOpen(false)
        isOpen(false)
    }


    return <Dialog open={castingOpen} fullWidth={true} maxWidth={'xl'}>
        <DialogTitle>
            Zauber wirken ({castingSpell?.name})
            {castingSpell ? <Button onClick={(e) => handlePopOpen(castingSpell.name, e)}>
                <QuestionMarkIcon/>
            </Button> : null}
        </DialogTitle>
        <DialogContent style={{position: 'relative'}}>
            {castingSpell && targetOpen ? <Paper
                style={{padding: '20px 24px', position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, zIndex: 100}}>
                {castingSpell.castdiff === 'MVZ' ? chooseSingleTarget() : null}
                {['MVE', 'MVG', 'MVG+', '6MVG', '6MVZ', 'MVZm6'].includes(castingSpell.castdiff) ? chooseMultipleTarget() : null}
            </Paper> : null}
            {castingSpell && castingTalent && usedSpell ? <Grid container>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6" gutterBottom>
                            Wirkschwierigkeit:
                        </Typography>
                        {castingSpell.castdiff === 'MVE' ?
                            <span>Magische Verteidigung jedes Zeils im Wirkungsbereich</span> : null}
                        {castingSpell.castdiff === 'MVG' ?
                            <span>Höchste Magische Verteidigung der Ziele</span> : null}
                        {castingSpell.castdiff === 'MVG+' ?
                            <span>Höchste Magische Verteidigung der Ziele +1 für jedes zusätzliche Ziel</span> : null}
                        {castingSpell.castdiff === 'MVS' ?
                            <span>Eigene Magische Verteidigung</span> : null}
                        {castingSpell.castdiff === 'MVZa' ?
                            <span>Charaktere, die der Zauberer astral gespürt hat (siehe S. 123), können als Zusätzliche Ziele mit dem Zauber belegt werden, was die Wirkschwierigkeit jeweils um +1 erhöht</span> : null}
                        {castingSpell.castdiff === 'MVZ' ?
                            <span>Magische Verteidigung des Ziels</span> : null}
                        {castingSpell.castdiff === '6MVG' ?
                            <span>Zuerst gegen 6, dann gegen höchste Magische Verteidigung der Ziele</span> : null}
                        {castingSpell.castdiff === '6MVZ' ?
                            <span>Zuerst gegen 6, dann gegen die Magische Verteidigung des Ziels</span> : null}
                        {castingSpell.castdiff === 'MVZm6' ?
                            <span>Magische Verteidigung des Ziels, mindestens 6</span> : null}
                        {castingSpell.castdiff === 'VAR' ? <span>variabel, siehe text</span> : null}
                        {['VAR', '6MVG', '6MVZ', 'MVZm6'].includes(castingSpell.castdiff) ? <Select key={v4()}
                                                                                                    value={castingVS}
                                                                                                    onChange={(e) => setCastingVS(e.target.value as number)}>
                            {diff.map(p => <MenuItem key={v4()} value={p}>{p}</MenuItem>)}
                        </Select> : null}
                        {['MVZ', 'MVE', 'MVG', 'MVG+', '6MVG', '6MVZ', 'MVZm6'].includes(castingSpell.castdiff) ?
                            <Button
                                onClick={() => setTargetOpen(true)}>{targets.length > 0 ? 'auswahl ändern' : 'auswählen'}</Button>
                            : null}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <List dense={true} sx={{width: '100%', bgcolor: 'background.paper'}}>
                            {Array.from(s_chars.value.entries()).map(([, char]) => {
                                if (targets.includes(char.id))
                                    return (
                                        <ListItem>{char.name}</ListItem>
                                    )
                                else return null
                            })}
                        </List>
                    </Grid>
                    <Grid item xs={12}>
                        mit: {castingTalent?.name} Stufe: {castingTalent?.step} + {ccAttribute(castingTalent?.attribute, 'tt')}
                        {castingTalent.strain > 0 ? <span>Überanstrengung: {castingTalent?.strain}</span> : null}
                    </Grid>
                    {castingSpell.threadswoven - usedSpell.threads > 0 ?
                        <Grid container>
                            <Grid item xs={6}>
                                Zusätzliche Fäden: {castingSpell.threadswoven - castingSpell.threads}
                            </Grid>
                            <Grid item xs={6}>
                                <FormGroup style={{marginLeft: 4}}>
                                    {usedSpell.at.map((at, i) => <FormControlLabel
                                            key={v4()}
                                            label={at.txt}
                                            control={
                                                <Checkbox
                                                    key={v4()}
                                                    onClick={() => setCastingAt(chooseAt(at.txt))}
                                                    style={{marginLeft: 8}}
                                                    checked={castingAt.includes(at.txt)}
                                                />
                                            }
                                        />
                                    )}
                                </FormGroup>
                            </Grid>
                        </Grid>
                        :
                        null
                    }

                    {castingTalent ? <Grid container>
                        <Grid item xs={12}>
                            <hr/>
                            <Typography variant="h6" gutterBottom>
                                Spruchzauberei
                            </Typography>
                        </Grid>
                        {castingTalent?.karma ? <FormControlLabel
                            label="Karma"
                            style={{paddingLeft:12}}
                            control={
                                <Checkbox
                                    checked={castingKarma}
                                    onChange={(e) => setCastingKarma(e.target.checked)}
                                />
                            }
                        /> : null}
                        <Select key={v4()}
                                value={castingMod}
                                onChange={(e) => setCastingMod(e.target.value as number)}
                        >
                            <ListSubheader>Modifikator</ListSubheader>
                            {mod_15.map(r => <MenuItem key={v4()} value={r}>{r}</MenuItem>)}
                        </Select>
                        <Button onClick={() => castingRoll()}>würfeln</Button>
                    </Grid> : null}

                    {castingResult ?
                        <Grid container>
                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>
                                    Spruchzauberei-Ergebnis
                                </Typography>
                                <div>Stufe: {castingResult.step} Ergebnis: {castingResult.result}</div>
                                <div>Gewürfelt: {castingResult.rolled} {displayMod(castingResult.step_mod)}
                                    {castingResult.karma ? ' Karma ' + castingResult.karma : ''}
                                </div>
                                {castingVS <= castingResult.result ? <div>
                                    <div>Zusätzliche Erfolge {castingResult.successes}</div>
                                    {castingResult.successes > 0 ?
                                        <div>{usedSpell.as.txt}</div> : null}
                                </div> : null}
                            </Grid>
                            {usedSpell.eff ?
                                <Grid item xs={12}>
                                    <Typography variant="h6" gutterBottom>
                                        Wirkung
                                    </Typography>
                                    <div>{usedSpell.eff}</div>
                                    <div>Dauer: {usedSpell.dur}</div>
                                    {usedSpell.eff_roll ?
                                        <div>
                                            <FormControlLabel
                                                label="Karma"
                                                control={
                                                    <Checkbox
                                                        checked={effKarma}
                                                        onChange={(e) => setEffKarma(e.target.checked)}
                                                    />
                                                }
                                            />
                                            <Select key={v4()}
                                                    value={effMod}
                                                    onChange={(e) => setEffMod(e.target.value as number)}
                                            >
                                                <ListSubheader>Modifikator Wirkung</ListSubheader>
                                                {mod_15.map(r => <MenuItem key={v4()} value={r}>{r}</MenuItem>)}
                                            </Select>
                                            <Button onClick={() => effectRoll()}>würfeln</Button>
                                        </div>
                                        : null
                                    }
                                </Grid>
                                : null
                            }
                            {effectResult ?
                                <Grid item xs={12}>
                                    <hr/>
                                    <Typography variant="h6" gutterBottom>
                                        Wirkung-Ergebnis
                                    </Typography>
                                    <Grid item xs={12}>Stufe: {effectResult.step} Ergebnis: {effectResult.result}</Grid>
                                    <Grid item xs={12}>Gewürfelt: {effectResult.rolled} {displayMod(effectResult.step_mod)}
                                        {effectResult.karma ? ' Karma ' + effectResult.karma : ''}
                                    </Grid>
                                </Grid>
                                : null
                            }
                        </Grid>
                        : null
                    }
                </Grid>
                : null
            }
        </DialogContent>

        <DialogActions>
            {castingResult && castingResult.result ?
                <Button onClick={() => castingRollDone()}>abschliessen</Button> : null
            }
            {targetOpen ?
                <Button onClick={() => setTargetOpen(false)}>auswahl schliessen</Button> : null
            }
            <Button onClick={() => castclose()}>abbrechen</Button>
        </DialogActions>
    </Dialog>

}

export default MatriceSpellCasting;
